<template>
    <div
        class="our-select has-cursor-pointer"
        :class="dropdownClass"
    >
        <dropdown-input
            :value="value"
            id="handle"
            :options="groupedFields"
            :is-grouped="true"
            group-label="label"
            group-options-key="fields"
            :close-on-select="false"
            ref="dropdown"
            :show-icon="false"
            input-placeholder="Search Fields"
            v-on:selected="select($event.event, $event.option)"
            v-on:close="onClose()"
            v-on:open="dropdownClass = 'is-opened'"
        >
            <template slot="selected-option">
                <div class="flex-con is-grow input">
                    <div>
                        <span class="icon is-small">
                            <i
                                class="fa"
                                :class="{
                                    'fa-cog' : isDefaultSearch(),
                                    'fa-flask' : isActiveProjectionSearch(),
                                    'fa-cube' : !isDefaultSearch() && !isActiveProjectionSearch() && value.length === 1,
                                    'fa-cubes' : !isDefaultSearch() && !isActiveProjectionSearch() && value.length > 1,
                                }"
                            ></i>
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:option="{ option : field }">
                {{field.name}}
                <a
                    v-if="field.handle === defaultFieldHandle"
                    class="icon help-icon m-l-xs"
                    @click="openHelpModal($event)"
                >
                    <i class="fa fa-question-circle-o"></i>
                </a>
            </template>
            <template slot="no-results">
                <div class="has-text-centered">
                    <i>No Matching Fields</i>
                </div>
            </template>
        </dropdown-input>
        <modal
            :active="helpModalActive"
            :close="() => { helpModalActive = false }"
            :is-card="true"
        >
            <template v-slot:header>
                <slot name="default-search-modal-header">
                    <div class="modal-card-title">Default Search Fields</div>
                </slot>
            </template>

            <slot name="default-search-modal-body"></slot>
        </modal>
    </div>
</template>

<script>
import SearchUtil from '../util/SearchUtil';
import _ from 'underscore';
import DropdownInput from '../../../elements/DropdownInput';

const defaultFields = [
    {
        name : 'Default Search Fields',
        handle : SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE,
    },
    {
        name : 'Active View',
        handle : SearchUtil.ACTIVE_PROJECTION_HANDLE,
    }
];

export default {
    name : "SearchSelection",
    components : {
        DropdownInput,
    },
    props : {
        value : {
            required : false,
        },
        searchableFieldsGroups : {
            type : Array,
            required : true,
        },
    },
    data () {
        return {
            changed : false,
            dropdownClass : 'is-closed',
            defaultFieldHandle : SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE,
            helpModalActive : false,
        }
    },
    computed : {
        groupedFields () {
            const groups = [{
                label : 'Defaults',
                fields : defaultFields,
            }];
            this.searchableFieldsGroups.forEach(group => {
                groups.push({
                    label : group.groupName,
                    fields : group.fields,
                });
            });
            return groups;
        },
    },
    methods : {
        select ($event, field) {
            let addToSelected = $event.metaKey || $event.ctrlKey;
            let handles = this.value.slice();
            let remove = false;

            if(this.value.indexOf(field.handle) !== -1){
                remove = true;
                handles = _.without(this.value, field.handle);
            } else {
                handles.push(field.handle);
            }

            this.changed = true;

            //most recently selected is always the last index
            const mostRecent = field.handle;

            //wipe out other selections when default is most recently selected
            if(mostRecent === SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE){
                this.$emit('input', [SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE]);
            }
            //wipe out other selections when active projection is most recently selected
            else if(mostRecent === SearchUtil.ACTIVE_PROJECTION_HANDLE){
                this.$emit('input', [SearchUtil.ACTIVE_PROJECTION_HANDLE]);
            }
            else if(!this.value.length){
                this.$emit('input', [SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE]);
            }
            //if we aren't adding as additional we only want to use the most recent
            else if(!remove && !addToSelected) {
                this.$emit('input', [mostRecent]);
            }
            //otherwise fine
            //but remove default and active projection
            else {
                this.$emit('input', _.without(handles, SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE, SearchUtil.ACTIVE_PROJECTION_HANDLE));
            }

            if(!addToSelected){
                this.$refs.dropdown.toggle();
            }
        },
        onClose () {
            this.dropdownClass = 'is-closed';
            if(this.changed) {
                this.changed = false;
                this.$emit('refresh');
            }
        },
        isDefaultSearch () {
            return this.value[0] === SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE;
        },
        isActiveProjectionSearch () {
            return this.value[0] === SearchUtil.ACTIVE_PROJECTION_HANDLE;
        },
        openHelpModal ($event) {
            $event.stopPropagation();
            this.helpModalActive = true;
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/theme';
    .our-select {
        &.is-closed {
            width:40px;
        }
        &.is-opened {
            width:auto;
        }
        .flex-con {
            cursor:pointer;
            height:100%;
            text-align:center;
            background-color:$white;
        }
    }
    /deep/ .dropdown-item.is-active {
        .help-icon {
            color:$white;
        }
    }
</style>
